import { render, staticRenderFns } from "./MiniBoxplot.vue?vue&type=template&id=4044005c&scoped=true"
import script from "./MiniBoxplot.vue?vue&type=script&lang=js"
export * from "./MiniBoxplot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4044005c",
  null
  
)

export default component.exports